/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IAssetCreateOauthMutationVariables = Types.Exact<{
  softwareEscrowId: Types.Scalars['ID']['input'];
  integrationId: Types.Scalars['ID']['input'];
  assetsParams: Array<Types.IAssetCreateOauthParams> | Types.IAssetCreateOauthParams;
}>;

export type IAssetCreateOauthMutation = {
  __typename?: 'Mutation';
  assetCreateOauth?: {
    __typename?: 'AssetCreateOauthPayload';
    success: boolean;
    errors?: Array<string> | null;
    assets?: Array<{
      __typename?: 'Asset';
      id: string;
      softwareEscrow:
        | { __typename?: 'SaasEscrow'; id: string; depositorConfigured: boolean }
        | { __typename?: 'SoftwareEscrow'; id: string; depositorConfigured: boolean };
    }> | null;
  } | null;
};

export const AssetCreateOauthDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'assetCreateOauth' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'softwareEscrowId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'integrationId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'assetsParams' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'AssetCreateOauthParams' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assetCreateOauth' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'softwareEscrowId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'softwareEscrowId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'integrationId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'integrationId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'assetsParams' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'assetsParams' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'softwareEscrow' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'depositorConfigured' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IAssetCreateOauthMutation, IAssetCreateOauthMutationVariables>;
